import React, { Component } from "react";
import { Col } from "reactstrap";

class ServiceBox extends Component {
  renderPreview() {
    const { variant } = this.props;

    return (
      <div className={`pwlp-service-preview pwlp-service-preview--${variant}`}>
        {variant === "payroll-dashboard" && (
          <div className="pwlp-mock pwlp-mock-payroll">
            <div className="pwlp-mock-window">
              <div className="pwlp-mock-window__header">
                <span>Payroll Dashboard</span>
                <div className="pwlp-dots">
                  <span />
                  <span />
                  <span />
                </div>
              </div>
              <div className="pwlp-payroll-list">
                <div className="pwlp-payroll-row">
                  <div className="pwlp-avatar pwlp-avatar--green" />
                  <div className="pwlp-lines">
                    <span />
                    <span />
                  </div>
                  <div className="pwlp-tag pwlp-tag--green">Paid</div>
                </div>
                <div className="pwlp-payroll-row">
                  <div className="pwlp-avatar pwlp-avatar--blue" />
                  <div className="pwlp-lines">
                    <span />
                    <span />
                  </div>
                  <div className="pwlp-tag pwlp-tag--blue">Paid</div>
                </div>
                <div className="pwlp-payroll-row">
                  <div className="pwlp-avatar pwlp-avatar--pink" />
                  <div className="pwlp-lines">
                    <span />
                    <span />
                  </div>
                  <div className="pwlp-tag pwlp-tag--yellow">Pending</div>
                </div>
              </div>
            </div>
          </div>
        )}

        {variant === "employee-portal" && (
          <div className="pwlp-mock pwlp-mock-portal">
            <div className="pwlp-portal-card">
              <div className="pwlp-portal-top">
                <div className="pwlp-portal-avatar" />
                <div className="pwlp-portal-lines">
                  <span />
                  <span />
                </div>
                <div className="pwlp-check-dot" />
              </div>
            </div>
            <div className="pwlp-portal-menu">
              <div>Pay Stubs</div>
              <div>Time Off</div>
              <div>Settings</div>
            </div>
          </div>
        )}

        {variant === "tax-calculator" && (
          <div className="pwlp-mock pwlp-mock-tax">
            <div className="pwlp-tax-card">
              <div className="pwlp-tax-header">Tax Calculator</div>
              <div className="pwlp-tax-row"><span>Federal Tax</span><strong>22%</strong></div>
              <div className="pwlp-tax-row"><span>State Tax</span><strong>5.5%</strong></div>
              <div className="pwlp-tax-row"><span>FICA</span><strong>7.65%</strong></div>
              <div className="pwlp-tax-total"><span>Total Deduction</span><strong>35.15%</strong></div>
            </div>
          </div>
        )}

        {variant === "invoice-estimates" && (
  <div className="pwlp-mock pwlp-mock-invoice">
    <div className="pwlp-invoice-card">

      <div className="pwlp-invoice-top">
        <div className="pwlp-invoice-title">
          Invoice #1024
        </div>

        <div className="pwlp-invoice-badge">
          Estimate
        </div>
      </div>

      <div className="pwlp-invoice-lines">
        <div className="pwlp-invoice-line full" />
        <div className="pwlp-invoice-line medium" />
        <div className="pwlp-invoice-line short" />
      </div>

      <div className="pwlp-invoice-total">
        <span>Total</span>
        <strong>$4,250</strong>
      </div>

    </div>
  </div>
)}

        {variant === "benefits-admin" && (
          <div className="pwlp-mock pwlp-mock-benefits">
            <div className="pwlp-benefits-grid">
              <div>Health</div>
              <div>Dental</div>
              <div>401(k)</div>
              <div>Vision</div>
            </div>
          </div>
        )}

        {variant === "analytics-dashboard" && (
          <div className="pwlp-mock pwlp-mock-analytics">
            <div className="pwlp-phone">
              <div className="pwlp-phone__screen">
                <div className="pwlp-bars">
                  <span />
                  <span />
                  <span />
                  <span />
                  <span />
                </div>
                <div className="pwlp-growth">+24% this month</div>
              </div>
            </div>
          </div>
        )}

        {variant === "check-writer" && (
  <div className="pwlp-mock pwlp-mock-check">
    <div className="pwlp-check-card">

      <div className="pwlp-check-top">
        <div className="pwlp-check-bank">
          Business Check
        </div>

        <div className="pwlp-check-number">
          #1052
        </div>
      </div>

      <div className="pwlp-check-payee" />

      <div className="pwlp-check-memo" />

      <div className="pwlp-check-bottom">
        <div className="pwlp-check-amount">
          $2,450
        </div>

        <div className="pwlp-check-status">
          Printed
        </div>
      </div>

    </div>
  </div>
)}

        {variant === "multi-company" && (
          <div className="pwlp-mock pwlp-mock-company">
            <div className="pwlp-company-list">
              <div className="primary">Company no. 1</div>
              <div>Company no. 2</div>
              <div>Company no. 3</div>
            </div>
          </div>
        )}

        {variant === "reconciliation" && (
  <div className="pwlp-mock pwlp-mock-reconciliation">
    <div className="pwlp-recon-card">
      <div className="pwlp-recon-header">Reconciliation</div>

      <div className="pwlp-recon-row">
        <span>Payroll Match</span>
        <span className="pwlp-recon-status pwlp-recon-status--matched">
          Matched
        </span>
      </div>

      <div className="pwlp-recon-row">
        <span>Bank Transaction</span>
        <span className="pwlp-recon-status pwlp-recon-status--matched">
          Matched
        </span>
      </div>

      <div className="pwlp-recon-row">
        <span>Cash Activity</span>
        <span className="pwlp-recon-status pwlp-recon-status--pending">
          Review
        </span>
      </div>
    </div>
  </div>
)}
      </div>
    );
  }

  render() {
    const { title, description } = this.props;

    return (
      <Col lg="4" md="6" className="pwlp-services-col">
        <div className="pwlp-services-box">
          {this.renderPreview()}
          <h4>{title}</h4>
          <p>{description}</p>
        </div>
      </Col>
    );
  }
}

export default ServiceBox;



// import React, { Component } from "react";
// import { Col} from "reactstrap";

// class ServiceBox extends Component {
//   render() {
//     return (
//       <React.Fragment>
//         <Col lg="4" className="mt-4">
//           <div className="services-box">
//             <div className="d-flex">
//               <i className={this.props.icon + " text-primary"}></i>
//               <div className="ms-4">
//                 <h4>{this.props.title}</h4>
//                 <p className="pt-2 text-muted">{this.props.description}</p>
//               </div>
//             </div>
//           </div>
//         </Col>
//       </React.Fragment>
//     );
//   }
// }

// export default ServiceBox;
